export class LocalitaDTO {
	comune: string;
	provincia: string;
	cap: string;
	nazione: string;
}